import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router, ParamMap } from "@angular/router";
import { ThemePalette } from "@angular/material/core";
@Component({
  selector: "app-standard-search-filter",
  templateUrl: "./standard-search-filter.component.html",
  styleUrls: ["./standard-search-filter.component.scss"],
})
export class StandardSearchFilterComponent implements OnInit {
  searchQuery: string;
  showSuggestions :boolean = false;
  suggestionResults :any =["Drive Thru","Drive Thru","Drive Thru",]
  filterOptions: any = [
    { id: "0", option: "All" },
    { id: "1", option: "Global Building Standards" },
    { id: "2", option: "Global Equipment Standards" },
    { id: "3", option: "Global Operation Standards" },
    { id: "4", option: "Global Approved Solutions" },
    { id: "5", option: "Upcoming Standards" },

  ]; 
  selectedOption: any;
  searchColor: ThemePalette = "primary";
  invalidQuery: Boolean = false;

  constructor(private route: ActivatedRoute, private router: Router) {}
  ngOnInit() {
    this.route.queryParamMap.subscribe((params: ParamMap) => {
      this.searchQuery = params.get("query") || "";
   
      this.selectedOption =
        this.filterOptions.find((e) => e.id == params.get("type")) ||
        this.filterOptions[0]; // Set default option if not provided
    });
  }

  selectOption(option: any, event: Event) {
    event.stopPropagation();
    console.log(option);
    this.selectedOption = option;
  }
  onSearchInputChange(){
    console.log("Query changes", this.searchQuery)
    this.showSuggestions = this.searchQuery.length > 2;
  }

  apply() {
    if (this.searchQuery == "") {
      this.invalidQuery = true;
      return;
    }
    this.invalidQuery = false;
    this.showSuggestions = false;
    this.router.navigate(["/standards-search"], {
      queryParams: { query: this.searchQuery, type: this.selectedOption.id },
    });
  }
  show(){
    // alert("clicked")
  }
  showAlert(event: KeyboardEvent) {
    console.log("Updated Query:", this.searchQuery);
  }  
}
